module.exports = __webpack_public_path__ + "static/parade-2020-house16-3a152e052b393fb0a2c22a50f1c54ea3.jpg";